import axios from "axios";
import { processAxiosError } from "../processAxiosError";
import { TlfItemReadDto } from "./TlfItemReadDto";
import { ITlfItemReturn } from "./patchTlfItem";
import { tlfPreProcess } from "./tlfPreProcess";

export interface SaveNewTlfItemDetails {
  tlfItem: TlfItemReadDto;
}

/**
 * Save a newly created TLF template to settings and return the saved item.
 *
 * @param backEndUrl - Base backend URL
 * @param saveDetails - Details including the TLF item to save
 * @param controller - Optional AbortController for cancelling the request
 * @returns Saved TLF item wrapped in ITlfItemReturn
 */
export const SaveNewTlfItem = async (
  backEndUrl: string,
  saveDetails: SaveNewTlfItemDetails,
  controller?: AbortController,
): Promise<ITlfItemReturn> => {
  try {
    const tlfKey = saveDetails.tlfItem.id.charAt(0).toUpperCase() + saveDetails.tlfItem.id.slice(1);
    if (!tlfKey.startsWith("New")) throw new Error("The item was not New");
    const res = await axios.put(
      `${backEndUrl}Settings/${tlfKey}`,
      { value: JSON.stringify(saveDetails.tlfItem) },
      controller ? { signal: controller.signal } : undefined,
    );
    return { success: true, data: tlfPreProcess(JSON.parse(res.data.value)) };
  } catch (error: unknown) {
    return processAxiosError("Save new TLF template failed", error);
  }
};
